import React, { useState } from "react";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import getUserGroup from "../../shared/components/getUserGroup";

const sanitizeInput = (input) => {
  return input
    .replace(/<[^>]*>?/gm, "")
    .replace(/[`$%^&*|\\]/g, "")
    .trim();
};

const AddEvolution = ({ selectedPatient, onClose }) => {
  const [observation, setObservation] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sanitizedObservation = sanitizeInput(observation);

    if (!sanitizedObservation) {
      setError(
        "El texto no puede estar vacío ni incluir caracteres no permitidos."
      );
      return;
    }

    try {
      const db = getFirestore();
      const patientRef = doc(db, "registeredPatients", selectedPatient.id);

      const today = new Date().toISOString().split("T")[0];

      const userData = await getUserGroup(true);
      const userFullName = `${userData.name} ${userData.surname}`;

      const evolutionKey = `Evolución_${today}_${Date.now()}`;

      const newEvolution = {
        observation: sanitizedObservation,
        date: today,
        user: userFullName,
      };

      await updateDoc(patientRef, {
        [`evolutions.${evolutionKey}`]: newEvolution,
      });

      setSuccess("Se guardó la evolución correctamente.");
      setObservation("");
      setError("");
    } catch (error) {
      setError("Ocurrió un error al guardar la evolución.");
    }
  };

  return (
    <div>
      <h2>Registrar evolución</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <textarea
            id="observation"
            name="observation"
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
            className="generalFormInput"
            placeholder="Escribe una evolución..."
            rows="4"
          ></textarea>
        </div>
        <button type="submit">Guardar</button>
      </form>
    </div>
  );
};

export default AddEvolution;
